import { StyledTheme } from '../SideSection/common.types';
import React from 'react';

// Create an enum for filled and outlined button variants
export enum ButtonVariant {
  Filled = 'filled',
  Outlined = 'outlined',
}

export interface ButtonProps {
  title: string;
  size: ButtonSize;
  disabled: boolean;
  textColor: string;
  hoverTextColor: string;
  buttonColor: string;
  variant: ButtonVariant;
  onClick: () => void;
  className?: string;
  id?: string;
  style?: React.CSSProperties;
  type?: 'submit' | 'button' | 'reset';
}

export interface ButtonStyleProps {
  size: ButtonSize;
  textColor: StyledTheme;
  hoverTextColor: StyledTheme;
  buttonColor: StyledTheme;
  variant: ButtonVariant;
}

export type ButtonSize = 'small' | 'medium' | 'large' | 'full';
